(() => {
  if (window.eliteMobileCustomFlowReady) return;
  window.eliteMobileCustomFlowReady = true;
  const mobile = window.matchMedia('(max-width: 999px)');
  const moved = new Map();
  const arrange = () => {
    const main = document.getElementById('main');
    if (!main) return;
    main.querySelectorAll('.product-info__block-item--contact').forEach(block => {
      if (moved.has(block) || !block.querySelector('form[action*="contact"]')) return;
      const section = block.closest('[data-section-type="product"]');
      const meta = section?.querySelector('.product-info__block-item--product-meta');
      if (!meta) return;
      const marker = document.createComment('custom-contact-desktop-position');
      block.before(marker);
      const id = `mobile-custom-contact-${section.dataset.sectionId}`;
      block.id = block.id || id;
      const destination = document.createElement('div');
      destination.className = 'container em-mobile-custom-contact';
      destination.hidden = true;
      main.append(destination);
      const card = document.createElement('div');
      card.className = 'card';
      const inner = document.createElement('div');
      inner.className = 'card__section';
      card.append(inner);
      destination.append(card);
      const jump = document.createElement('a');
      const inquiry = block.querySelector('.eq[id]');
      jump.href = `#${inquiry?.id || block.id}`;
      jump.className = 'em-mobile-custom-jump em-contact-glow';
      jump.textContent = block.querySelector('[data-inquiry-label]')?.dataset.inquiryLabel || block.querySelector('button[type="submit"]')?.textContent.trim();
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '↓';
      jump.append(arrow);
      meta.after(jump);
      moved.set(block, { marker, destination, inner, jump });
    });
    moved.forEach((state, block) => {
      if (!state.marker.isConnected) {
        state.destination.remove();
        state.jump.remove();
        moved.delete(block);
        return;
      }
      if (mobile.matches) {
        state.inner.append(block);
        if (state.destination !== main.lastElementChild) main.append(state.destination);
        state.destination.hidden = false;
      } else {
        state.marker.after(block);
        state.destination.hidden = true;
      }
    });
  };
  const initialize = () => {
    arrange();
    if (!mobile.matches || !window.location.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(window.location.hash.slice(1))); }
    catch { return; }
    if (target?.closest('.em-mobile-custom-contact')) {
      window.requestAnimationFrame(() => {
        if (mobile.matches) (target.closest('.eq') || target).scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  mobile.addEventListener('change', arrange);
  document.addEventListener('shopify:section:load', arrange);
})();

